<template>
    <div>
        <loading v-if="!isLoaded" :active="true" :params="params"></loading>
        <template v-else>
            <results-header :params="params"></results-header>
            <filters :packages="packages" @filters-applied="applyFilteredPackages"></filters>
            <results :packages="filteredPackages" :total-packages="packages.length" @quote="quote"></results>
        </template>
        <quote-modal ref="quoteModal"></quote-modal>
    </div>
</template>

<script>
    import Loading from './Loading';
    import ResultsHeader from './ResultsHeader';
    import Filters from './Filters';
    import Results from './Results';
    import QuoteModal from './QuoteModal';
    import VueScrollTo from 'vue-scrollto';

    export default {
        props: [
            'params',
        ],
        data: function() {
            return {
                packages: [],
                filteredPackages: [],
                quotedPackage: null,
            };
        },
        computed: {
            isLoaded() {
                return this.packages.length > 0;
            }
        },
        components: {
            loading: Loading,
            resultsHeader: ResultsHeader,
            filters: Filters,
            results: Results,
            QuoteModal
        },
        methods: {
            fetchResults() {
                if (this.packages.length > 0) {
                    return;
                }
                axios.get(this.params.searchExecUrl).then((response) => {
                    if (response.data.success) {
                        if (response.data.complete) {
                            if (response.data.packages.length == 0) {
                                // somehow we got no packages, try refreshing
                                window.location = this.params.searchResultUrl + '&new_search=1';
                            }
                            //search complete
                            this.packages = this.filteredPackages = response.data.packages;
                            this.applyPreselection();
                        } else {
                            // search not complete, check again after a delay
                            setTimeout(this.fetchResults(), 5000);
                        }
                    } else if (response.data.redirect) {
                        window.location = response.data.redirect;
                    } else if (response.data.reload) {
                        window.location.reload();
                    }
                });
            },
            applyPreselection() {
                this.$nextTick(() => {
                    if (this.params.preselected_package) {
                        VueScrollTo.scrollTo('#car-' + this.params.preselected_package);
                    }
                });
            },
            applyFilteredPackages(packages) {
                this.filteredPackages = packages;
            },
            quote(carPackage) {
                this.$refs.quoteModal.quotePackage(carPackage);
            }
        },
        mounted() {
            this.fetchResults();
        }
    };
</script>

<style scoped>
</style>